/**
 * Tradução de `activity_type` (slug) para texto de paciente em português.
 *
 * Os slugs vêm de `HealthKitTypes.activityName()` (iOS) e
 * `HealthConnectTypes.exerciseName()` (Android) — os MESMOS nas duas
 * plataformas de propósito, então esta tradução também serve para as duas.
 *
 * Tipo não mapeado (`activity_<n>`, ou algo novo que o SDK passe a emitir)
 * cai no fallback: capitaliza o slug em vez de mostrar código cru. Perder a
 * tradução bonita é aceitável; mostrar "activity_46" ao paciente não é.
 */
const ACTIVITY_LABEL: Record<string, string> = {
  running: 'Corrida',
  walking: 'Caminhada',
  hiking: 'Caminhada na natureza',
  cycling: 'Ciclismo',
  pool_swimming: 'Natação em piscina',
  open_water_swimming: 'Natação em águas abertas',
  rowing: 'Remo',
  elliptical: 'Elíptico',
  stair_climbing: 'Escada',
  strength_training: 'Musculação',
  functional_strength: 'Treino funcional',
  core_training: 'Treino de core',
  hiit: 'Treino intervalado (HIIT)',
  yoga: 'Yoga',
  pilates: 'Pilates',
  flexibility: 'Alongamento',
  mind_and_body: 'Mente e corpo',
  cooldown: 'Desaquecimento',
  mixed_cardio: 'Cardio misto',
  cross_training: 'Cross training',
  dance: 'Dança',
  soccer: 'Futebol',
  basketball: 'Basquete',
  tennis: 'Tênis',
  volleyball: 'Vôlei',
  golf: 'Golfe',
  martial_arts: 'Luta',
  climbing: 'Escalada',
  surfing: 'Surfe',
  paddle_sports: 'Canoagem/Stand-up paddle',
  water_sports: 'Esporte aquático',
  downhill_skiing: 'Esqui',
  cross_country_skiing: 'Esqui cross-country',
  snowboarding: 'Snowboard',
  skating: 'Patinação',
  jump_rope: 'Pular corda',
  tai_chi: 'Tai chi',
  barre: 'Barre',
  wheelchair: 'Cadeira de rodas',
  triathlon: 'Triatlo',
  diving: 'Mergulho',
  other: 'Atividade física',
};

export function activityLabel(slug: string | null): string {
  if (!slug) return 'Atividade física';
  const known = ACTIVITY_LABEL[slug];
  if (known) return known;
  // Fallback: "activity_46" ou algo novo do SDK vira "Activity 46" em vez de
  // código cru. Não é bonito, mas nunca é ilegível.
  return slug
    .replace(/_/g, ' ')
    .replace(/\b\w/g, (c) => c.toUpperCase());
}
